
























import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import { JobsStore } from '@/models/jobs/jobs.vuex';
import router from '../router';
import VueToastr from '@deveodk/vue-toastr';
import Container from './Registration/Container.vue';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import JobReferraldetails from './JobReferraldetails.vue';
import CompanyReferral from './CompanyReferral.vue';
import AppReferral from './AppReferral.vue';
import { JobReferralWrapper } from '../models/jobs/jobreferralwrapper';
import { Company } from '../models/company/companyprofile';
import { CandidatePortalClientCommonInfo } from '../models/utility/lookup';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'WLReferralMain',
  components: {
    WLReferralMain,
    JobReferraldetails,
    CompanyReferral,
    AppReferral,
    Container,
  },
})
export default class WLReferralMain extends Vue {
  $wlToastr: any;
  private referralEventType: string = '';

  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  mounted() {
    const vm = this;
    const rCode = this.$route.params.referralCode;
    if (this.$route.query.fbclid && !this.$route.query.utm_source) {
      console.log('this.$route.query.fbclid encountered');
      this.$router.push({ name: 'Findjobs' });
      setTimeout(() => {
        this.$router.push({
          name: 'WLReferralMain',
          params: { referralCode: rCode },
        });
      });
      return;
    }
    const candidatePortalClientCommonInfo = new CandidatePortalClientCommonInfo();
    candidatePortalClientCommonInfo.radius = vxm.jobs.FilterRadius;
    candidatePortalClientCommonInfo.latitude = vxm.jobs.latitude;
    candidatePortalClientCommonInfo.longitude = vxm.jobs.longitude;
    candidatePortalClientCommonInfo.referralCode = rCode;
    candidatePortalClientCommonInfo.companyCode = vxm.users.getCompanyCode;

    const respPromise: any = vxm.referrals.getJobReferral(
      candidatePortalClientCommonInfo,
    );
    Promise.all([respPromise]).then((values) => {
      const JWrapper = values[0];
      console.log(JWrapper);
      if (!vxm.referrals.ReferralWrapper.status) {
        const errorMessageText =
          vxm.referrals.ReferralWrapper.errorMessageKey !== ''
            ? vxm.referrals.ReferralWrapper.errorMessageKey
            : 'referral.referralCode.invalid';
        vm.$wlToastr('error', vm.$t(errorMessageText), 'Referral');
        router.push({ name: 'Findjobs' });
      } else {
        vm.referralEventType = JWrapper.referralEventType;

        if (JWrapper.referralEventType === 'APP_REFERRAL') {
          vm.referralEventType = 'APP_REFERRAL';
        }
        if (JWrapper.referralEventType === 'REFER_FRIEND_REFERRAL') {
          vm.referralEventType = 'REFER_FRIEND_REFERRAL';
        }
        if (JWrapper.referralEventType === 'COMPANY_REFERRAL') {
          let company = new Company();
          company = JWrapper.companyInfo;
          vxm.jobs.setCompanyInfo(company);
          vm.referralEventType = 'COMPANY_REFERRAL';
        }
        if (JWrapper.referralEventType === 'JOB_REFERRAL') {
          vm.referralEventType = 'JOB_REFERRAL';
        }
      }
    });
  }
}
